import { render, staticRenderFns } from "./ProgClients.vue?vue&type=template&id=24a9ee0b"
import script from "./ProgClients.vue?vue&type=script&lang=js"
export * from "./ProgClients.vue?vue&type=script&lang=js"
import style0 from "./ProgClients.vue?vue&type=style&index=0&id=24a9ee0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports